import { mapDashboardResponse } from '@/mappers/dashboard.mapper';

import apiClient from '@/lib/api-client';
import { raiseAxiosErrorOrDefault } from '@/lib/error';
import { buildQueryParams } from '@/lib/utils';

import type { AuditLog, AuditLogFilterParams } from '@/types/audit-log.type';
import type { PaginatedResponse } from '@/types/common.type';
import type { DashboardFilters, DashboardResponse } from '@/types/dashboard.type';

/**
 * Fetch dashboard data
 * @returns Dashboard statistics and metrics
 */
export const fetchDashboardData = async (filters: DashboardFilters): Promise<DashboardResponse> => {
  try {
    const response = await apiClient.get<DashboardResponse>('/dashboard', mapDashboardResponse, {
      params: {
        from_date: filters.from_date,
        to_date: filters.to_date,
        ...(filters.agent_id != null && { agent_id: filters.agent_id }),
      },
    });
    return response;
  } catch (e) {
    raiseAxiosErrorOrDefault(e, 'Failed to fetch dashboard data');
  }
};

export const fetchAuditLogs = async (
  params: AuditLogFilterParams
): Promise<PaginatedResponse<AuditLog>> => {
  try {
    const response = await apiClient.get<PaginatedResponse<AuditLog>>(
      '/dashboard/audit-logs',
      null,
      {
        params: buildQueryParams(params, {
          ...(params?.filters && { module: params.filters.module }),
        }),
      }
    );

    return response;
  } catch (e) {
    raiseAxiosErrorOrDefault(e, 'Failed to fetch audit logs');
  }
};
